// Internal modules
import { appStore } from '@/store';
import {
  getCheckoutSessionFlags,
  getToken,
  logger,
  parseGqlError,
} from '@/lib';
import { apolloClient } from '@/lib/apollo';
import { getErrorFromResponse } from '@/lib/apollo/utils';
import { UPGRADE_GUEST_TO_MEMBER_MUTATION } from './mutations';
import { serializeFormData } from '../../../Form/utils';
import { conditionallyDropLoginCookie } from '../../../../lib/utils';
import { pomaLogout } from '../../../PasswordlessOnboarding/utils';

import {
  handlePOBoxLine1AddressContingency,
  handleResidentialAddressContingency,
} from '../../../Form/graphql/errorHandlers';

const upgradeGuestToMember = () => {
  const { form: formState } = appStore.getState();
  const variables = serializeFormData(formState);
  //temp fix for 1-10% ramp
  variables.dateOfBirth = variables.dateOfBirth || {};
  const { ui: uiActions } = appStore.getActions();
  uiActions.toggleIsUpgradeInterstitialOpen(false);

  return upgradeCall(variables);
};

//separated out to improve testability
const upgradeCall = variables => {
  const { ui: uiActions } = appStore.getActions();

  return apolloClient
    .mutate({
      mutation: UPGRADE_GUEST_TO_MEMBER_MUTATION,
      variables,
    })
    .then(async () => {
      await conditionallyDropLoginCookie();
      pomaLogout().then(() => {
        uiActions.toggleIsWPSDonePageOpen(true);
      });
    })
    .catch(error => {
      logger.error('upgrade_guest_to_member_error', error);

      const gqlError = getErrorFromResponse(error);
      const { errorData, isResidentialAddressError, message } =
        parseGqlError(gqlError);
      // Invalid residential address, handle it separately
      if (isResidentialAddressError) {
        // Reopen upgrade interstitial for the user to submit it again
        uiActions.toggleIsUpgradeInterstitialOpen(true);
        uiActions.toggleIsFormSubmitting(false);

        return handleResidentialAddressContingency(errorData);
      }

      //WPS guest upgrade interstitial flow - pobox error
      if (message === 'ADDRESS_WORLD_READY_VALIDATION_ERROR') {
        const { isWPS } = getCheckoutSessionFlags();
        const integrationType = isWPS ? 'WPS' : 'EC';
        logger.fpti('weasley_poboxvalidation_ineligible_errorshown', {
          context_id: getToken(),
          context_type: `${integrationType}-token`,
          state_name: 'billing_poboxvalidation',
          transition_name: 'ineligible_pobox_errorshown',
        });
        uiActions.toggleIsFormSubmitting(false);
        return handlePOBoxLine1AddressContingency(errorData);
      }

      uiActions.toggleIsUpgradeErrorShown(true);
      uiActions.toggleIsWPSDonePageOpen(true);
    });
};

export { upgradeCall, upgradeGuestToMember };
